import {
  Office,
  OfficeAddress,
  OfficeAddressEditFormValues,
  OfficeAddressRow,
  OfficeEditFormValues,
  OfficeEmail,
  OfficeEmailEditFormValues,
  OfficeEmailRow,
  OfficeNote,
  OfficeNoteEditFormValues,
  OfficeNoteRow,
  OfficePhone,
  OfficePhoneEditFormValues,
  OfficePhoneRow,
  OfficeRow,
} from "./types";

/*---------------------------------------------------------------------------------------
    OFFICE
-----------------------------------------------------------------------------------------*/
export const transformOffice = (res: any): Office => ({
  id: res.id,
  name: res.name,
  code: res.code ?? null,
  internalMark: res.internalMark ?? null,
  description: res.description ?? null,
  status: res.status ?? null,
  primaryEmail: res.primaryEmail ?? null,
  primaryPhone: res.primaryPhone ?? null,
  primaryAddress: res.primaryAddress ?? null,
});

export const transformOfficeEditFormValues = (
  res: Office
): OfficeEditFormValues => ({
  id: res.id,
  name: res.name,
  code: res.code ?? null,
  internalMark: res.internalMark ?? null,
  description: res.description ?? null,
  status: res.status ?? "active",
});

/*---------------------------------------------------------------------------------------
    OFFICE SEARCH
-----------------------------------------------------------------------------------------*/
export const transformOfficeRow = (res: any): OfficeRow => ({
  id: res.id,
  name: res.name,
  code: res.code ?? null,
  internalMark: res.internalMark ?? null,
  description: res.description ?? null,
  status: res.status ?? null,
  primaryEmail: res.primaryEmail ?? null,
  primaryPhone: res.primaryPhone ?? null,
  primaryAddress: res.primaryAddress ?? null,
  created: res.created,
});

/*---------------------------------------------------------------------------------------
  OFFICE CREATE / UPDATE
-----------------------------------------------------------------------------------------*/
export const transformOfficeOnCreate = (
  formValues: OfficeEditFormValues
): any => ({
  name: formValues.name,
  code: formValues.code,
  internalMark: formValues.internalMark,
  description: formValues.description,
  status: formValues.status,
});

export const transformOfficeOnUpdate = (
  formValues: OfficeEditFormValues
): any => ({
  name: formValues.name,
  code: formValues.code,
  internalMark: formValues.internalMark,
  description: formValues.description,
  status: formValues.status,
});

/*---------------------------------------------------------------------------------------
  EMAIL
-----------------------------------------------------------------------------------------*/
export const transformOfficeEmailRow = (res: any): OfficeEmailRow => ({
  id: res.id,
  emailAddress: res.emailAddress,
  description: res.description,
  primary: res.primary,
});

export const transformOfficeEmail = (res: any): OfficeEmail => ({
  id: res.id,
  emailAddress: res.emailAddress,
  description: res.description,
  primary: res.primary,
});

export const transformOfficeEmailOnCreate = (
  formValues: OfficeEmailEditFormValues
): any => ({
  emailAddress: formValues.emailAddress,
  description: formValues.description,
  primary: formValues.primary,
});

export const transformOfficeEmailOnUpdate = (
  formValues: OfficeEmailEditFormValues
): any => ({
  emailAddress: formValues.emailAddress,
  description: formValues.description,
  primary: formValues.primary,
});

/*---------------------------------------------------------------------------------------
  PHONE
-----------------------------------------------------------------------------------------*/
export const transformOfficePhoneRow = (res: any): OfficePhoneRow => ({
  id: res.id,
  phoneTypeId: res.phoneTypeId,
  phoneNumber: res.phoneNumber,
  description: res.description,
  primary: res.primary,
});

export const transformOfficePhone = (res: any): OfficePhone => ({
  id: res.id,
  phoneTypeId: res.phoneTypeId,
  phoneNumber: res.phoneNumber,
  description: res.description,
  primary: res.primary,
});

export const transformOfficePhoneOnCreate = (
  formValues: OfficePhoneEditFormValues
): any => ({
  phoneTypeId: formValues.phoneTypeId,
  phoneNumber: formValues.phoneNumber,
  description: formValues.description,
  primary: formValues.primary,
});

export const transformOfficePhoneOnUpdate = (
  formValues: OfficePhoneEditFormValues
): any => ({
  phoneTypeId: formValues.phoneTypeId,
  phoneNumber: formValues.phoneNumber,
  description: formValues.description,
  primary: formValues.primary,
});

/*---------------------------------------------------------------------------------------
  ADDRESS
-----------------------------------------------------------------------------------------*/
export const transformOfficeAddressRow = (res: any): OfficeAddressRow => ({
  id: res.id,
  city: res.city,
  country: res.country,
  line1: res.line1,
  line2: res.line2,
  postalCode: res.postalCode,
  state: res.state,
  description: res.description,
  primary: res.primary,
  latitude: res.latitude,
  longitude: res.longitude,
});

export const transformOfficeAddress = (res: any): OfficeAddress => ({
  id: res.id,
  city: res.city,
  country: res.country,
  line1: res.line1,
  line2: res.line2,
  postalCode: res.postalCode,
  state: res.state,
  description: res.description,
  primary: res.primary,
  latitude: res.latitude,
  longitude: res.longitude,
});

export const transformOfficeAddressOnCreate = (
  formValues: OfficeAddressEditFormValues
): any => ({
  city: formValues.city,
  country: formValues.country,
  line1: formValues.line1,
  line2: formValues.line2,
  postalCode: formValues.postalCode,
  state: formValues.state,
  description: formValues.description,
  primary: formValues.primary,
  latitude: formValues.latitude,
  longitude: formValues.longitude,
});

export const transformOfficeAddressOnUpdate = (
  formValues: OfficeAddressEditFormValues
): any => ({
  city: formValues.city,
  country: formValues.country,
  line1: formValues.line1,
  line2: formValues.line2,
  postalCode: formValues.postalCode,
  state: formValues.state,
  description: formValues.description,
  primary: formValues.primary,
  latitude: formValues.latitude,
  longitude: formValues.longitude,
});

/*---------------------------------------------------------------------------------------
  NOTE
-----------------------------------------------------------------------------------------*/
export const transformOfficeNoteRow = (res: any): OfficeNoteRow => ({
  id: res.id,
  content: res.content,
  important: res.important,
  created: res.created,
});

export const transformOfficeNote = (res: any): OfficeNote => ({
  id: res.id,
  content: res.content,
  important: res.important,
  created: res.created,
});

export const transformOfficeNoteOnCreate = (
  formValues: OfficeNoteEditFormValues
): any => ({
  content: formValues.content,
  important: formValues.important,
});

export const transformOfficeNoteOnUpdate = (
  formValues: OfficeNoteEditFormValues
): any => ({
  content: formValues.content,
  important: formValues.important,
});

/*---------------------------------------------------------------------------------------
  PEOPLE
-----------------------------------------------------------------------------------------*/
